<div class="page-section" id="page-series-listing">
	<div class="page-section-header">
		<div class="page-section-btn">
			<!-- <a (click)="doCreate()" (keypress)="doCreate()" class="btn btn-primary btn-with-icon"
				translate>Create New Series</a>
		</div> -->
		<h1>Series</h1>
	</div>
	<div class="page-section-content">

		<mat-tab-group>
			<mat-tab>
				<ng-template mat-tab-label>
					<span (click)="onSelectTab(0)">Video Series</span>					
				</ng-template>
				<div class="page-section">
					<div class="page-section-header">
						<div class="page-section-buttons">
							<a (click)="doCreate('video')" (keypress)="doCreate('video')" class="btn btn-primary btn-with-icon"
				translate>Create New Video Series</a>
						</div>
						<!-- <h1 translate>Video Series</h1> -->
					</div>
					<div class="page-section-content">
						<page-loader *ngIf="!isLoaded"></page-loader>
						<div class="table-responsive" *ngIf="isLoaded">
							<table class="table">
								<thead>
									<tr>
										<th style="width:25%;" translate>Name</th>
										<th style="width:25%;"></th>
										<th style="width:25%;"></th>
										<th style="width:25%;"></th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let course of courses">
										<td>{{course.label}}  <span *ngIf ="course.active === 0">(Unpublished)</span></td>
										<td><a tabindex="0" class="pull-right"  [routerLink]="'/app/series-listing/' + course.key"
											 translate>View</a></td>
										<td><a tabindex="0" class="pull-right" (click)="onEdit(course.id,'video')"
											(keypress)="onEdit(course.id,'video')" translate>Edit</a></td>
										<td><a class="trigger-modal delete pull-right" tabindex="0" aria-label="Delete series" (click)="delete(course.id,'video')"
											(keypress)="delete(course.id,'video')"><img src="./assets/img/icons-svg/x-icon.svg"></a></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</mat-tab>

			<mat-tab>
				<ng-template mat-tab-label>
					<span (click)="onSelectTab(0)">Voice Series</span>					
				</ng-template>
				<div class="voice-subtab">
					<mat-tab-group >
						<mat-tab>
							<ng-template mat-tab-label>
								<span (click)="onSelectTab(1)">Stories</span>
							</ng-template>
							<div class="page-section">
								<div class="page-section-header">
									<div class="page-section-buttons">
										<a (click)="doCreate('stories')" (keypress)="doCreate('stories')" class="btn btn-primary btn-with-icon"
							translate>Create New Stories</a>
									</div>
									<!-- <h1 translate>Video Series</h1> -->
								</div>
								<div class="page-section-content">
									<page-loader *ngIf="!isLoaded"></page-loader>
									<div class="table-responsive" *ngIf="isLoaded">
										<table class="table">
											<thead>
												<tr>
													<th style="width:30%;" translate>Title</th>
													<th style="width:15%;"> Author</th>
													<th style="width:15%;">Category</th>
													<th style="width:5%;"></th>
													<th style="width:5%;"></th>
													<th style="width:5%;"></th>
												</tr>
											</thead>
											<tbody>
												<tr *ngIf = "storyList.length === 0" >
													<td colspan="5" class="no-data-message">No data found</td>
												</tr>
												<tr *ngFor="let course of storyList">
													<td>{{course.titleen}}</td>
													<td>{{course.authoren}}</td>
													<td>{{course.category}}</td>
													<td><a tabindex="0" class="pull-right" (click) = "viewRoute('stories',course.id)"
														translate>View</a></td>
													<td><a tabindex="0" class="pull-right" (click)="onEdit(course.id,'stories')"
														(keypress)="onEdit(course.id,'stories')" translate>Edit</a></td>
													<td><a class="trigger-modal delete pull-right" tabindex="0" aria-label="Delete series" (click)="delete(course.id,'stories')"
														(keypress)="delete(course.id,'stories')"><img src="./assets/img/icons-svg/x-icon.svg"></a></td>
												</tr>												
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</mat-tab>

						<mat-tab>
							<ng-template mat-tab-label>
								<span (click)="onSelectTab(2)">Burning Questions</span>
							</ng-template>
							<div class="page-section">
								<div class="page-section-header">
									<div class="page-section-buttons">
										<a (click)="doCreate('burningquestion')" (keypress)="doCreate('burningquestion')" class="btn btn-primary btn-with-icon"
							translate>Create New Burning Questions</a>
									</div>
									<!-- <h1 translate>Video Series</h1> -->
								</div>
								<div class="page-section-content">
									<page-loader *ngIf="!isLoaded"></page-loader>
									<div class="table-responsive" *ngIf="isLoaded">
										<table class="table">
											<thead>
												<tr>
													<th style="width:30%;" translate>Question</th>
													<th style="width:15%;"> Counselor Name</th>
													<th style="width:15%;">Category</th>
													<th style="width:5%;"></th>
													<th style="width:5%;"></th>
													<th style="width:5%;"></th>
												</tr>
											</thead>
											<tbody>
												<tr *ngIf = "burningQuestionList.length === 0" >
													<td colspan="5" class="no-data-message">No data found</td>
												</tr>
												<tr *ngFor="let course of burningQuestionList">
													<td>{{course.titleen}}</td>
													<td>{{course.authoren}}</td>
													<td>{{course.category}}</td>
													<td><a tabindex="0" class="pull-right" (click) = "viewRoute('burningQuestions', course.id)"
														translate>View</a></td>
													<td><a tabindex="0" class="pull-right" (click)="onEdit(course.id,'burningquestion')"
														(keypress)="onEdit(course.id,'burningquestion')" translate>Edit</a></td>
													<td><a class="trigger-modal delete pull-right" tabindex="0" aria-label="Delete series" (click)="delete(course.id,'burningquestion')"
														(keypress)="delete(course.id,'burningquestion')"><img src="./assets/img/icons-svg/x-icon.svg"></a></td>
												</tr>									
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</mat-tab>
					</mat-tab-group>
				</div>
			</mat-tab>

			<mat-tab>
				<ng-template mat-tab-label>
					<span (click)="onSelectTab(0)">Daily </span>					
				</ng-template>
				<div class="page-section">
					<div class="page-section-header">
						<div class="header-row">
						  	<div class="drop-down-field">
								<mat-form-field class="wt-mat-form-field">
									<mat-select name="userType" [(ngModel)]="selectedGroupId" (selectionChange)="valueChange($event)" [disabled]="!dailyGroups || dailyGroups.length === 0">
										<mat-option *ngFor="let g of dailyGroups" [value]="g.ID">{{ g.Name }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="page-section-buttons">
								<a (click)="doCreate('daily')" (keypress)="doCreate('daily')" class="btn btn-primary btn-with-icon" translate>
								Import New Daily Contents
								</a>
							</div>
							<div class="page-section-buttons" *ngIf="dailyList?.length != 0">
								<a (click)="doAdd('daily')" (keypress)="doAdd('daily')" class="btn btn-primary btn-with-icon" translate>
								Add to Existing Daily Content
								</a>
							</div>
						</div>
					</div>
					<div class="page-section-content">
						<page-loader *ngIf="!isLoaded"></page-loader>
						<div class="table-responsive" *ngIf="isLoaded">
							<table class="table">
								<thead>
									<tr>
										<th style="width:8%;" translate>Serial No</th>
										<th style="width:8%;" translate>Category ID</th>
										<th style="width:6%;" translate>Category</th>
										<th style="width:25%;" translate>Daily Boost-English</th>
										<th style="width:25%;" translate>Daily Boost-French</th>
										<th style="width:25%;" translate>Daily Boost-Spanish</th>
										<th style="width:3%;"></th>
									</tr>
									<tr>
                                    <th></th>
									<th></th>
                                    <th>
                                        <mat-form-field class="wt-mat-form-field"><input matInput type="text"
                                                class="wt-mat-input" [(ngModel)]="cols[0]" (input)="filterValue(0)">
                                        </mat-form-field>
                                    </th>
                                    <th></th>
									<th></th>
									<th></th>
                                </tr>
								</thead>
								<tbody >
									<tr *ngIf="dailyList?.length === 0">
										<td colspan="5" class="no-data-message">No data found</td>
									  </tr>
									<tr *ngFor="let daily of dailyList; let i = index">
  										<td>{{ i + 1 }}</td>
										<td>{{daily.categoryid}}</td>
										<td>{{daily.categorytitle}}</td>
										<td [innerHTML]="daily.quotesen"></td>
										<td [innerHTML]="daily.quotesfr"></td>
										<td [innerHTML]="daily.quoteses"></td>
										<td><a tabindex="0" class="pull-right" (click)="onEdit(daily.id,'daily')"
											(keypress)="onEdit(daily.id,'daily')" translate>Edit</a></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</mat-tab>
		</mat-tab-group>
	</div>
</div>
